// extracted by mini-css-extract-plugin
module.exports = {"date":"ProcedureTableInfo_date__2GJFE","head":"ProcedureTableInfo_head__2rZgT"};